module.exports = __webpack_public_path__ + "assets/cf6d3dcd72fc19aabc1ad596808768ed.png";